export default function (props: any) {
    return (
        <svg width="52" height="52" viewBox="0 0 52 52" xmlns="http://www.w3.org/2000/svg">
            <g fill="none" fillRule="evenodd">
                <path d="M0 0h52v52H0z" />
                <g stroke="#000">
                    <path
                        d="M26.513 44.936c5.633.001 10.309-4.683 10.297-10.315C36.8 28.957 32.165 24.31 26.521 24.3c-5.705-.01-10.364 4.657-10.347 10.366.018 5.649 4.668 10.27 10.339 10.27z"
                        strokeWidth="1.5"
                    />
                    <path d="M14.11 34.674c.021 6.778 5.603 12.325 12.406 12.326 6.76.001 12.372-5.62 12.358-12.378" strokeWidth="1.5" />
                    <path strokeWidth="1.5" strokeLinejoin="round" d="M12.066 5h4.155v2.856l-.978 1.815.978 1.76v7.076H12v-7.076l.978-1.76L12 7.856V5h4.154" />
                    <path
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M40.985 10.634v7.872h-4.222v-7.872zM37.836 10.186v-4.13a1.055 1.055 0 0 1 2.11 0v4.13h0"
                    />
                    <path
                        strokeWidth="1.5"
                        d="M14.11 34.674V18.507M38.874 34.622V18.507M26.508 42.533c4.32 0 7.907-3.592 7.9-7.913-.01-4.344-3.565-7.91-7.894-7.917-4.376-.008-7.95 3.572-7.937 7.95.014 4.334 3.581 7.879 7.931 7.88z"
                    />
                    <path d="m14.11 13.162.001 2.744" />
                </g>
            </g>
        </svg>
    );
}
